import Antiphishing from './Antiphishing';

export default Antiphishing;
